<template>
  <div class="varianted-cost" v-if="variant.prices">
    <router-link
      :to="{
        name: 'tec-estimate-variant',
        params: {
          typeId: getSelectedCar.typeId,
          korId: variant.work.korId,
          itemMpId: variant.work.ItemMpId,
          workId: 0, // FIXME: Małysz co tu powinno być?
        },
      }"
      class="link-to-variant"
    >
      <div class="title">
        <div>{{ variant.prices.name }}</div>
      </div>
    </router-link>
    <div
      class="estimated-cost d-flex justify-content-between"
      v-if="variant.prices.estimatedMax || !variant.prices.hasPrices"
    >
      <div class="description">szacowany koszt</div>
      <div class="cost" v-if="!variant.prices.hasPrices">
          dane częściowe
      </div>
      <div class="cost" v-else>
        {{ thousands(variant.prices.estimatedMin) }} -
        {{ thousands(variant.prices.estimatedMax) }} zł
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data: function () {
    return {};
  },
  props: {
    variant: {},
  },
  methods: {
    thousands(num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
  },
  computed: {
    ...mapGetters("cars", ["getSelectedCar"]),
  },
};
</script>
<style scoped>
.varianted-cost {
  margin-top: 8px;
  padding-bottom: 10px;
}

.title {
  font-size: 18px;
}

.subtitle {
  font-size: 14px;
  font-weight: bold;
  margin-top: -5px;
}

.link-to-variant {
  color: black;
}

.estimated-cost {
  font-size: 14px;
  width: 100%;
}

.estimated-cost .description {
  margin-right: 5px;
  color: rgba(121, 121, 121, 1);
}

.estimated-cost .cost {
  color: var(--brand-pink);
  font-weight: bold;
}

.cost-description {
  margin-left: 100px;
}

.cost-description .bold {
  font-weight: bold;
  font-size: 14px;
}
.cost-description .cost {
  color: var(--brand-pink);
  font-size: 14px;
  font-weight: bold;
}
</style>
